import { mixins, Options } from "vue-class-component";

import TableMixin from "./TableMixin";
import { Prop } from "vue-property-decorator";

@Options({})
export default class AppTable extends mixins(TableMixin) {
    @Prop({ default: true })
    readonly showHeader: boolean;
}